<div class="bg-[#491176] min-h-screen">
	<portals-navbar></portals-navbar>
	<div class="background-container" style="background-color: #340254; display: flex; justify-content: center; align-items: center">
		<div class="content-container" style="text-align: center">
			<h1 class="m-0">JOTTO BUNDLES</h1>
			<p style="margin-bottom: 35px; max-width: 830px; width: 80vw">Whether you're just starting out or need a comprehensive solution, we have a plan to fit your needs.</p>
			<div class="pricing-container mx-auto">
				<div class="pricing-plans">
					<!-- Starter -->
					<div class="pricing-plan bg-[#F1E5D9] p-6 flex flex-col justify-between items-stretch" style="border-radius: 10px">
						<div>
							<h2>Starter</h2>
							<h3>
								$899
								<!-- <span class="price" style="display: inline block; margin-left: -5px">
							/mo
							<br />
						</span>
						<span class="price" style="display: block; margin-bottom: 40px">$899 billed annually</span> -->
							</h3>

                            <button (click)="redirectToPaymentStarter()" class="buy-button">Buy Now!</button>
                            <div class="pricing-details">
                                <div class="feature-item">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black"/>
                                    </svg>
                                    <span class="feature-text">2,500 Responses</span>
                                </div>
                                <div class="feature-item">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black"/>
                                    </svg>
                                    <span class="feature-text">50 News Alert</span>
                                </div>
                                <div class="feature-item">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black"/>
                                    </svg>
                                    <span class="feature-text">1 AI Report</span>
                                </div>
                                <div class="feature-item">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black"/>
                                    </svg>
                                    <span class="feature-text">1 Administrator</span>
                                </div>
                            </div>
                        </div>
                        <div class="px-4">
                            <div class="w-full !text-left mt-6">
                                <span class="feature-text !text-left !mb-0">Includes:</span>
                            </div>
                            <ul class="!mt-2 !pl-4">
                                <li>Unlimited Channels</li>
                                <li>Unlimited Word Clouds</li>
                                <li>Unlimited Prompts</li>
                                <li>(Scroll down for more)</li>
                            </ul>
                        </div>
                    </div>
                    <!-- Pro -->
                    <div class="pricing-plan bg-[#F1E5D9] p-6 flex flex-col justify-between items-stretch" style="border-radius: 10px">
                        <div>
                            <h2>Pro</h2>
                            <h3>
                                $2,499
                                <!-- <span class="price" style="display: inline block; margin-left: -5px">
                            /mo
                            <br />
                        </span>
                        <span class="price" style="display: block; margin-bottom: 40px">$149.92 billed annually</span> -->
                            </h3>
                            <button (click)="redirectToPaymentPro()" class="buy-button">Buy Now!</button>

							<div class="pricing-details">
								<div class="feature-item">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black" />
									</svg>
									<span class="feature-text">10,000 Responses</span>
								</div>
								<div class="feature-item">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black" />
									</svg>
									<span class="feature-text">150 News Alerts</span>
								</div>
								<div class="feature-item">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black" />
									</svg>
									<span class="feature-text">3 Team Members</span>
								</div>
								<div class="feature-item">
									<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="black" />
									</svg>
									<span class="feature-text">4 AI Reports</span>
								</div>
							</div>
						</div>
						<div class="px-4">
							<div class="w-full !text-left mt-6"><span class="feature-text !text-left !mb-0">Everything Starter Plus:</span></div>
							<ul class="!mt-2 !pl-4">
								<li>Channel Theming</li>
								<li>Branded Word Clouds</li>
								<li>Personalized Links</li>
								<li>(Scroll down for more)</li>
							</ul>
						</div>
					</div>
					<div class="pricing-plan bg-[#F1E5D9] p-6" style="border-radius: 10px; display: flex; flex-direction: column; justify-content: space-between">
						<h2>Custom</h2>
						<h3>
							Let's Talk
							<!-- <span class="price" style="display: inline block; margin-left: -5px">
							/mo
							<br />
						</span>
						<span class="price" style="display: block; margin-bottom: 40px">$899 billed annually</span> -->
						</h3>
						<div class="px-4">
							<div class="w-full flex flex-col justify-center items-center">
                                <div class="border-3 border-[#491176] rounded-lg">
                                    <ngx-qrcode-styling [config]="getVariedConfig(200, 200)"></ngx-qrcode-styling>
                                </div>
                                <a href="https://jotto.me/custom-plan" target="_blank" class="bg-[#fbd354] mt-2 text-lg cursor-pointer h-10 rounded-xl px-4 py-1 font-extrabold border border-[#c6c6c6]">jotto.me/custom-plan</a>
							</div>
							<div class="w-full !text-left mt-6"><span class="feature-text !text-left !mb-0">Options Include:</span></div>
							<ul class="!mt-2 !pl-4">
								<li>Customized AI Reports</li>
								<li>White Labeling Apps</li>
								<li>API Integrations</li>
								<li>(Scroll down for more)</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div style="text-align: center" class="mb-4">
				<span class="upgrade-description">Every plan includes 12 months of portal access.</span>
				<br />
				<span class="upgrade-description">Non-profit pricing upon request.</span>
			</div>
			<div class="py-16">
				<div class="max-w-6xl mx-auto">
					<h2 class="text-center text-3xl !font-bold text-[#FECB3E] mb-8">COMPARE PLANS</h2>
					<div class="overflow-x-auto shadow-lg rounded-lg">
						<table class="w-full text-left text-white rounded-lg overflow-hidden">
							<thead>
								<tr class="bg-[#FBD354]">
									<th class="p-6 text-[#491176] font-semibold text-xl">Features</th>
									<th class="p-6 text-[#491176] text-lg text-center">Starter</th>
									<th class="p-6 text-[#491176] text-lg text-center">Pro</th>
									<th class="p-6 text-[#491176] text-lg text-center">Custom</th>
								</tr>
							</thead>
							<tbody>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#350254a2]">
									<td class="px-4 py-2 text-lg">Responses</td>
									<td class="px-4 py-2 text-center text-lg">2,500</td>
									<td class="px-4 py-2 text-center text-lg">10,000</td>
									<td class="px-4 py-2 text-center text-lg">Custom</td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#350254a2]">
									<td class="px-4 py-2 text-lg">News Alerts</td>
									<td class="px-4 py-2 text-center text-lg">50</td>
									<td class="px-4 py-2 text-center text-lg">150</td>
									<td class="px-4 py-2 text-center text-lg">Custom</td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#350254a2]">
									<td class="px-4 py-2 text-lg">Administrators</td>
									<td class="px-4 py-2 text-center text-lg">1</td>
									<td class="px-4 py-2 text-center text-lg">3</td>
									<td class="px-4 py-2 text-center text-lg">Custom</td>
								</tr>

								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#350254a2]">
									<td class="px-4 py-2 text-lg">AI Reports</td>
									<td class="px-4 py-2 text-center text-lg">1</td>
									<td class="px-4 py-2 text-center text-lg">4</td>
									<td class="px-4 py-2 text-center text-lg">Custom</td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#350254a2]">
									<td class="px-4 py-2 text-lg">Unlimited Channels</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Unlimited Prompts</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Unlimited Word Clouds</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Direct Messaging to Users</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Analytics</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Curb Users</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Response Collections</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Response Filtering</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Response Tagging</td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Channel Theming</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Response Triggers</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Branded Word Clouds</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Personalized Links</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">Customized AI Reports</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">White Labeling</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors border-b-[0.5px] border-b-[#340254]">
									<td class="px-4 py-2 text-lg">API Integration</td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"></td>
									<td class="px-4 py-2 text-center"><span class="text-[#340254]">&#x2714;</span></td>
								</tr>
								<tr class="bg-[#f1e5d9] text-black hover:bg-[#f9f3ea] transition-colors">
									<td class="px-4 py-2 text-lg">Customer Support</td>
									<td class="px-4 py-2 text-center text-lg">Email</td>
									<td class="px-4 py-2 text-center text-lg">Email</td>
									<td class="px-4 py-2 text-center text-lg">
										Email, Phone,
										<br />
										Video
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
			<div class="choose-jotto text-center">
				<span class="image-container-title">WHY CHOOSE JOTTO?</span>
				<div class="image-container">
					<div class="feature">
						<div class="image-circle mx-auto rounded-full overflow-hidden relative group bg-[#2A0243] border-[#fbd354] flex items-center justify-center">
							<img src="assets/images/engage.png" alt="Feature 1" class="object-cover transition-transform duration-300 transform group-hover:scale-110" style="margin-left: -15.6%; width: 75%; height: auto" />
						</div>
						<h3 class="image-title">ENGAGE</h3>
						<p class="image-paragraph">Easily gather candid feedback through video, audio, and text.</p>
					</div>
					<div class="feature">
						<div class="image-circle mx-auto rounded-full overflow-hidden relative group bg-[#2A0243] border-[#fbd354] flex items-center justify-center">
							<img src="assets/images/analyze.png" alt="Feature 2" class="object-cover transition-transform duration-300 transform group-hover:scale-110" style="margin-bottom: 12.5%; width: 40%; height: auto" />
						</div>
						<h3 class="image-title">ANALYZE</h3>
						<p class="image-paragraph">Our AI transforms feedback into actionable insights, trends, and recommendations.</p>
					</div>
					<div class="feature">
						<div class="image-circle mx-auto rounded-full overflow-hidden relative group bg-[#2A0243] border-[#fbd354] flex items-center justify-center">
							<img src="assets/images/succeed.png" alt="Feature 3" class="object-cover transition-transform duration-300 transform group-hover:scale-110" style="width: 45%; height: auto" />
						</div>
						<h3 class="image-title">SUCCEED</h3>
						<p class="image-paragraph">Use these insights to make informed decisions and drive success.</p>
					</div>
				</div>
			</div>
			<div class="disclaimer">
				<hr class="disclaimer-divider" />
				<span class="disclaimer-text">Note: Prices and plans are subject to change. Please check our website for the most up-to-date information. Plans automatically renew after 12 months
                    unless upgraded or canceled before.</span>
			</div>
		</div>
	</div>
	<portals-footer></portals-footer>
</div>
